import React from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomTabset from "../Components/CustomTabset/CustomTabset";
import {globals} from "../Components/Globals/Globals.js";
import { loadHirings } from "../redux/hiringSlice.js";

// reactstrap components
import {Container, Row} from "reactstrap";

// core components
import HiringsRawTableDataSync from "../Components/HiringsRawTableDataSync/HiringsRawTableDataSync";


const AdminHiringsView = (props) => {
  const dispatch = useDispatch();

  // Get the stats from the store
  const {hiringsItems, loadHirings_result} = useSelector((state) => state.hirings)
  
  React.useEffect(() => {
    // eslint-disable-next-line no-unused-vars
    let isMounted = true

    // If status is !loading, then fetch stats data from the API
    if (loadHirings_result.status === 'idle'){
      if (globals.parameters.redux_debugging) alert("loading hirings")
      dispatch(loadHirings());
    }

    if (loadHirings_result.status === 'loading'){
      if (globals.parameters.redux_debugging) alert("loading hirings...")
    }

    // If status is !loading, then fetch stats data from the API
    if (loadHirings_result.status === 'succeeded'){
      if (globals.parameters.redux_debugging) alert("hirings successfully loaded")
        console.log("AdminHiringsView -> hiringsItems", hiringsItems)
    }

    // Cleanup function
    return () => {
      isMounted = false
    }
  }, [loadHirings_result, dispatch]);


  return (    
        <div className="wrapper">
          <div className="main">
            <div className="section">
              <Container>
                {/** Search toolbar */}
                <CustomTabset activeTabset={"hirings"}/>
                <Row>
                  <div>
                      {hiringsItems  &&
                      <HiringsRawTableDataSync
                        hiring_list = {hiringsItems}
                        current_session={null}
                        //stat_filter={stat_or_admin_filter()}
                        stat_filter={null}/>}                 
                </div>
                </Row> 
              </Container>
            </div>
          </div>
        </div>
  );
}

export default AdminHiringsView;
